"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCustomizeViewContainer = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const product_customize_view_constants_1 = require("./product-customize-view.constants");
const product_customize_view_styles_1 = require("./product-customize-view.styles");
const table_customize_view_1 = require("./table-customize-view");
const use_get_attributes_as_columns_1 = require("../client/use-get-attributes-as-columns");
const use_products_table_columns_config_hook_1 = require("../hooks/use-products-table-columns-config.hook");
const table_columns_1 = require("../../../../../common/table-columns");
const attributes_1 = require("../../../../../constants/attributes");
const generic_1 = require("../../../../../generic");
const product_table_dynamic_columns_1 = require("../../../../../hooks/product-table-dynamic-columns");
const utils_1 = require("../../../../../utils");
const feature_flags_1 = require("../../../../../../feature-flags");
const hooks_1 = require("../../../../../../hooks");
const localization_1 = require("../../../../../../localization");
const store_1 = require("../../../../../../store");
const ProductCustomizeViewContainer = ({ excludedColumns, columnsOrder, selectAllMode, filterOptions, onChangeColumns, onClose, productTreeNodeId, }) => {
    const { featureFlagsService } = (0, hooks_1.useFeatureFlagsService)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const columnsConfig = (0, use_products_table_columns_config_hook_1.useProductsTableColumnsConfig)({});
    const baseColumns = (0, react_1.useMemo)(() => columnsConfig.map(({ field, headerName, editable, }) => ({ id: field, label: headerName, isEditable: editable })), [columnsConfig]);
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const [filterAnchorEl, setFilterAnchorEl] = (0, react_1.useState)(null);
    const defaultFilterOptionsList = (0, react_1.useMemo)(() => {
        const options = [product_table_dynamic_columns_1.DynamicColumnsFilterOption.Original, product_table_dynamic_columns_1.DynamicColumnsFilterOption.Enriched];
        if (featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.Measures)) {
            options.push(product_table_dynamic_columns_1.DynamicColumnsFilterOption.Measures);
        }
        return options;
    }, [featureFlagsService]);
    const { excludedColumns: localExcludedColumns, columnsOrder: localColumnsOrder, selectAllMode: localSelectAllMode, filterOptions: localFilterOptions, isAllSelected, checkIsColumnSelected, actions: { toggleSelectAll, setOrder, onCheck, onChangeColumns: onChangeLocalColumns, }, } = (0, product_table_dynamic_columns_1.useCustomizeTableColumns)({
        options: {
            persisted: false,
        },
    });
    (0, react_1.useEffect)(() => {
        onChangeLocalColumns({
            excludedColumns,
            columnsOrder,
            selectAllMode: selectAllMode !== null && selectAllMode !== void 0 ? selectAllMode : false,
            filterOptions,
        });
    }, [onChangeLocalColumns, columnsOrder, excludedColumns, selectAllMode, filterOptions]);
    const handleApplyChanges = (0, react_1.useCallback)(() => {
        onChangeColumns({
            excludedColumns: localExcludedColumns,
            columnsOrder: localColumnsOrder,
            selectAllMode: localSelectAllMode,
            filterOptions: localFilterOptions,
        });
        onClose();
    }, [localColumnsOrder, localExcludedColumns, localFilterOptions, localSelectAllMode, onChangeColumns, onClose]);
    const existingIds = (0, react_1.useMemo)(() => columnsConfig.map(({ field }) => (0, table_columns_1.parseColumnId)(field).label), [columnsConfig]);
    const { pagination: { isLoadingMore, hasNextPage, onNextPage, }, isLoading, error, attributes, } = (0, use_get_attributes_as_columns_1.useGetAttributesAsColumns)({
        catalogId,
        filterOptions: defaultFilterOptionsList,
        productTreeNodeId,
        productAttributeFilter: {
            label: {
                notIn: [...existingIds, attributes_1.PRODUCT_DESCRIPTION_LABEL],
            },
        },
    });
    const handleApplyFilterOptions = (selected) => {
        const newFilterOptions = selected !== null && selected !== void 0 ? selected : defaultFilterOptionsList;
        onChangeLocalColumns({ filterOptions: newFilterOptions });
        setFilterAnchorEl(null);
    };
    const filteredAttributes = (0, react_1.useMemo)(() => (0, use_get_attributes_as_columns_1.getAttributesByFilterOptions)(attributes, localFilterOptions), [attributes, localFilterOptions]);
    (0, react_1.useEffect)(() => {
        if (!isLoading && filteredAttributes.length) {
            const columnIds = (0, utils_1.sortByTextFieldCaseInsensitive)(utils_1.SortOrder.Ascend)([...baseColumns, ...filteredAttributes], 'label').map(({ id }) => id);
            const newColumnIds = (0, ramda_1.without)(localColumnsOrder, columnIds);
            if (newColumnIds.length) {
                onChangeLocalColumns({ columnsOrder: [...localColumnsOrder, ...newColumnIds] });
            }
        }
    }, [isLoading, localColumnsOrder, filteredAttributes, onChangeLocalColumns, baseColumns]);
    (0, react_1.useEffect)(() => {
        if (filteredAttributes.length && localExcludedColumns.length) {
            // remove columns that do not fit the filter options except the default
            const newExcludedColumns = localExcludedColumns.filter((columnId) => {
                if (table_columns_1.BASE_COLUMNS.find((id) => id === columnId)) {
                    return true;
                }
                const columnIndex = filteredAttributes.findIndex((attribute) => attribute.id === columnId);
                return columnIndex > -1;
            });
            if (newExcludedColumns.length !== localExcludedColumns.length) {
                onChangeLocalColumns({ excludedColumns: newExcludedColumns });
            }
        }
        // should be triggered only when local filter options are changed
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localFilterOptions, onChangeLocalColumns]);
    const columns = (0, react_1.useMemo)(() => baseColumns.concat(filteredAttributes.map(({ id, label, isEditable, }) => ({
        id,
        label,
        isEditable,
    }))), [filteredAttributes, baseColumns]);
    const orderedColumns = (0, react_1.useMemo)(() => {
        const columnMap = new Map(columns.map((column) => [column.id, column]));
        const newOrderedColumns = localColumnsOrder.map((id) => columnMap.get(id)).filter((column) => Boolean(column));
        return newOrderedColumns;
    }, [columns, localColumnsOrder]);
    const handleReorder = (0, react_1.useCallback)((id, targetId) => {
        const newLocalColumnsOrder = [...localColumnsOrder];
        const globalToIndex = localColumnsOrder.findIndex((itemId) => itemId === targetId);
        const globalFromIndex = localColumnsOrder.findIndex((itemId) => itemId === id);
        newLocalColumnsOrder.splice(globalFromIndex, 1);
        newLocalColumnsOrder.splice(globalToIndex, 0, id);
        setOrder(newLocalColumnsOrder);
    }, [localColumnsOrder, setOrder]);
    const multiSelectMenuOptions = (0, react_1.useMemo)(() => defaultFilterOptionsList.map((value) => ({
        value,
        label: t({ key: product_customize_view_constants_1.filterOptionToMessageKey[value] }),
        icon: value === product_table_dynamic_columns_1.DynamicColumnsFilterOption.Enriched ? react_1.default.createElement(product_customize_view_styles_1.StyledAISparkleIcon, { fill: ui_components_1.baseColors.blue300 }) : undefined,
    })), [defaultFilterOptionsList, t]);
    return (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(table_customize_view_1.TableCustomizeView, { isOpen: true, columns: orderedColumns, isLoadingMore: isLoadingMore, hasNextPage: hasNextPage, onLoadMore: onNextPage, error: error === null || error === void 0 ? void 0 : error.message, isLoading: isLoading, onClose: onClose, onApply: handleApplyChanges, onFilterOpen: setFilterAnchorEl, isFilterEnabled: localFilterOptions.length !== defaultFilterOptionsList.length, isAllSelected: isAllSelected, checkIsColumnSelected: checkIsColumnSelected, toggleSelectAll: toggleSelectAll, setOrder: handleReorder, toggleCheck: onCheck }), filterAnchorEl && (react_1.default.createElement(generic_1.MultiSelectMenu, { options: multiSelectMenuOptions, anchorEl: filterAnchorEl, onClose: () => setFilterAnchorEl(null), selected: localFilterOptions, onApply: handleApplyFilterOptions }))));
};
exports.ProductCustomizeViewContainer = ProductCustomizeViewContainer;
exports.default = exports.ProductCustomizeViewContainer;
